import { useTheme } from '@mui/material';
import { NextPage } from 'next';
import Head from 'next/head';

import Layout from '@/components/layouts/Layout';
import TermsOfUsePage from '@/components/widgets/pages/termsofuse-widget/TermsOfUsePage';
import { restaurantsThemes } from '@/styles/GlobalStyles';
import { brandServerSideProps } from '@/utils/brandServerSideProps';

interface ILayoutProps {
  children: React.ReactNode;
  footer: boolean;
  buttonCart: boolean;
}

interface IData {
  data: any;
}

const TermsOfUse: NextPage<IData> = () => {
  return <TermsOfUsePage />;
};

const withLayout = (Page: NextPage<IData>, Layout: React.FC<ILayoutProps>) => {
  // eslint-disable-next-line react/display-name
  return (props: IData) => {
    return (
      <Layout footer={true} buttonCart={true}>
        <Page {...props} />
      </Layout>
    );
  };
};
export const getServerSideProps = brandServerSideProps;

export default withLayout(TermsOfUse, (props: ILayoutProps) => {
  const theme = useTheme();
  const restaurantInfo = restaurantsThemes.find(hostObj => hostObj.name.includes(theme.name));
  const title = `Оферта | ${restaurantInfo?.displayName}`;
  const description = `Оферта | ${restaurantInfo?.description}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={description} />
        <meta property='og:title' content={title} />
        <meta property='og:description' content={description} />
      </Head>
      <Layout footer={true} buttonCart={true}>
        {props.children}
      </Layout>
    </>
  );
});
